export const selectedEmployee = obj => ({
  type: 'SELECTED_EMPLOYEE',
  obj
})
